import {
  Box,
  Card,
  Checkbox,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Button as MUIButton,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  NumberField,
  TopToolbar,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  TextInput,
  SelectInput,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { Resources } from '../../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';


const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();

  return (
    <DashboardContent>
      <PermissionGuard resource="swap-fee-config" action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={translate('resource.swapConfigFee')}
          links={[
            { name: translate('resource.swapConfig'), href: '#' },
            { name: translate('resource.swapConfigFee'), href: `/${Resources.swapConfigFee}` },
            { name: translate('resource.list') },
          ]}
          // action={
          //   <PermissionGuard resource="swap-fee-config" action="create" fallback={<></>}>
          //     <CreateButton variant="contained" size='medium' onClick={(e)=> {
          //       e.preventDefault()
          //       setPopup(<CreateMetadata onClose={() => setPopup(undefined)} />)
          //     }} />
          //   </PermissionGuard>
          // }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            perPage={10}
            exporter={false}
          >
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                sx={{
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                  '& .left-col': {
                    textAlign: 'left',
                  },
                }}
              >
                <TextField source="type" label="module.swapConfigFee.type" sortable={false} />
                <FunctionField
                  label="module.swapConfigFee.feeBps"
                  source="feeBps"
                  sortable={false}
                  cellClassName="left-col"
                  headerClassName="left-col"
                  render={(r: any) =>
                    r?.feeBps !== undefined && r?.feeBps !== null
                      ? `${Number(r.feeBps) / 100}%`
                      : '-'
                  }
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </PermissionGuard>
    </DashboardContent>
  );
};

export default View;
